import React, { useCallback } from "react"
import { Map } from "lucide-react"
import { motion } from "framer-motion"
import { isMobile } from "../../utils/detectDevice"
import { useAppDispatch } from "../../reducers/hooks"
import { showMobileMap } from "../../reducers/overlaysSlice"
import { mobileRoutes, setMobileRoute } from "../../routes/routes"
import { useMediaQuery } from "@react-hookz/web"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import { useTranslation } from "react-i18next"

type ShowMobileMapButtonProps = {
  className?: string
  shouldMoveUp?: boolean
}

const ShowMobileMapButton: React.FC<ShowMobileMapButtonProps> = (props) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const isSmallScreen = useMediaQuery("(max-width: 900px)")

  // Toggle mobile map drawer
  const handleShowMobileMap = useCallback(() => {
    dispatch(showMobileMap())
    setMobileRoute(mobileRoutes.CHAT_MAP)
  }, [dispatch])

  if (!isMobile && !isSmallScreen) return null

  return (
    <motion.div
      className="absolute bottom-[10px] right-5 z-[99]"
      animate={{
        y: props.shouldMoveUp ? -60 : 0,
      }}
      transition={{
        duration: 0.3,
        ease: "easeInOut",
      }}
    >
      <Button
        variant="floating"
        size="floating"
        onClick={handleShowMobileMap}
        aria-label={t("maps.showMobileMapButton.toggleMap")}
        id="mobileMapDrawerButton"
        className={cn("shadow-lg", props.className)}
      >
        <Map size={20} />
      </Button>
    </motion.div>
  )
}

export default ShowMobileMapButton
